import React from 'react';
import { faSunBright } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SunBrightRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faSunBright} {...props} />;
}
